import React from 'react';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { Safety } from './components/Safety';
import { Availability } from './components/Availability';
import { RepairVsReplace } from './components/RepairVsReplace';
import { SideRearGlass } from './components/SideRearGlass';
import { Insurance } from './components/Insurance';
import { Adas } from './components/Adas';
import { QuoteProcess } from './components/QuoteProcess';
import { WhyChoose } from './components/WhyChoose';
import { ServiceArea } from './components/ServiceArea';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyMobileCta } from './components/StickyMobileCta';
export function App() {
  return <main className="w-full min-h-screen bg-white font-sans text-slate-900 pb-20 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <TrustBar data-id="element-2" />
      <Services data-id="element-3" />
      <Safety data-id="element-4" />
      <Availability data-id="element-5" />
      <RepairVsReplace data-id="element-6" />
      <SideRearGlass data-id="element-7" />
      <Insurance data-id="element-8" />
      <Adas data-id="element-9" />
      <QuoteProcess data-id="element-10" />
      <WhyChoose data-id="element-11" />
      <ServiceArea data-id="element-12" />
      <Faq data-id="element-13" />
      <FinalCta data-id="element-14" />
      <StickyMobileCta data-id="element-15" />
    </main>;
}